import MPriceTable from './index.vue';

MPriceTable.install = app => {
  app.component(MPriceTable.name, MPriceTable);
};

export default MPriceTable;
